module.exports = "<div>\n    <router-outlet></router-outlet>\n    <app-share></app-share>\n</div>"